var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.isNameDisplayed)?[_c('b',[_vm._v(_vm._s(_vm.location.name))]),_c('br')]:_vm._e(),_vm._v(" "+_vm._s(_vm.location.address)+" "),_c('br'),_vm._v(" "+_vm._s(_vm.location.city)+", "+_vm._s(_vm.location.state)+" "+_vm._s(_vm.location.zip)+" ")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }